import React, { useCallback, useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import colors from '@totem/styles/colors';
import { debounce } from '@totem/utilities/debounce';

import './controlSystemReport.css';

const DEBOUNCE_TIME = 500;

const styles = {
  icon: {
    color: colors.neutral.gray,
  },
};
const NameSearch = () => {
  const { handleFilter } = useContext(InputContext);
  const handleSearch = useCallback(
    debounce((name: string) => handleFilter('searchName', name), DEBOUNCE_TIME),
    [],
  );

  return (
    <div styleName="search-bar">
      <Input
        placeholder="Search Control System"
        prefix={<SearchOutlined style={styles.icon} />}
        onChange={(event) => handleSearch(event.target.value)}
      />
    </div>
  );
};

export default NameSearch;
